import React from 'react';
import If from '../../common/components/if';
import LangCache from '../../base/langCache';
import { useEffect, useState } from 'react';
import { guideLog } from '../../dataServices/guideLog';
import { showExpireDialog } from '../expireConfirm/expireConfirm';
import { EnterpriseCountdown } from '../enterpriseCountdown/enterpriseCountdown';

import { VERSION_TYPE, IAccountPlan } from '../../interface/plan';

interface IProps {
    isAdmin: boolean;
    accountPlan: IAccountPlan;
}

export const EnterpriseCountdownNavItem = ({accountPlan, isAdmin}: IProps) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const isCommercialTrial = accountPlan.teacher_status === VERSION_TYPE.COMMERICAL_TRIAL;
        setShow(isCommercialTrial && accountPlan.expire_time * 1000 >= Date.now());
        if (!!+accountPlan.show_trial_overdue_dialog) {
            showExpireDialog();
        }
    }, [accountPlan]);

    const onCountDownMouseEnter = () => {
        if (isAdmin) {
            guideLog({page_type: 1, action_type: 1});
        }
    };

    const onExpire = () => {
        setShow(false);
        showExpireDialog();
    };

    const render = () => {
        if (!show) {
            return null;
        }
        const LANG = LangCache.getLang();
        const tipKey = '试用：剩余<span>{$0}</span>天';
        const countdownText = (LANG[tipKey]).replace('{$0}', `${accountPlan.expire_days}`);
        return (
            <li className="page-header-nav-item">
                <div className="btn btn-countdown">
                    <div className="btn-countdown-inner" onMouseEnter={onCountDownMouseEnter}>
                        <div dangerouslySetInnerHTML={{__html: countdownText}}></div>
                        <If condition={isAdmin}>
                            <i className="icon-fold"></i>
                        </If>
                        <If condition={isAdmin}>
                            <div className="enterprise-countdown-container">
                                <EnterpriseCountdown accountPlan={accountPlan} onExpire={onExpire}/>
                            </div>
                        </If>
                    </div>
                </div>
            </li>
        );
    };
    return render();
};
